export { default } from "./BrandListHeader";
